import React, { useRef } from "react";
import "./LinkSelectCSS.css";
import FileCopyTwoToneIcon from "@material-ui/icons/FileCopyTwoTone";
import { Tooltip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { changeHelpOrTipText } from "../store/components";
import { getBrokerInformation } from "../store/broker";
import { toast } from "react-toastify";
import translations from "../utils/translations";

export default function LinkSelect(props) {
  const { text, chs } = props;

  const dispatch = useDispatch();
  const brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;

  const textAreaRef = useRef(null);
  const iconcolor = props.iconcolor ? props.iconcolor : null;

  function copyToClipboard(e) {
    textAreaRef.current.select();
  }

  const handleFocus = () => {
    textAreaRef.current.select();
    document.execCommand("copy");
    if (!toast.isActive(1101)) {
      toast.success(translations[languagepreference].wholeLinkCopied, {
        autoClose: 1500,
        position: "top-center",
        toastId: 1101,
      });
    }
    dispatch(changeHelpOrTipText(translations[languagepreference].wholeLinkCopiedToClipboard));
  };

  const handleBlur = () => {
    dispatch(changeHelpOrTipText(""));
  };

  return (
    <div
      className="abd"
      onMouseOver={() => {
        dispatch(
          changeHelpOrTipText(
            chs
              ? ""
              : translations[languagepreference].linkShareWithInsurers
          )
        );
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    >
      <form
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "5vh",
        }}
      >
        <div
          className="textdiv"
          style={{
            height: "80%",
            width: "100%",
          }}
        >
          <input
            type="text"
            ref={textAreaRef}
            onFocus={handleFocus}
            onBlur={handleBlur}
            value={text}
            readOnly
            style={{
              border: 0,
              width: "100%",
              height: chs ? "100%" : "90%",
              fontFamily: "GibsonRegular",
              color: "grey",
              backgroundColor: "white",
              borderRadius: 15,
              fontSize: chs ? "1.5vmin" : "inherit",
            }}
          ></input>
        </div>
      </form>
      <div style={{ width: "5px", height: "100%" }}></div>
      {
        /* Logical shortcut for only displaying the 
          button if the copy command exists */
        document.queryCommandSupported("copy") && (
          <div style={{ cursor: "pointer" }}>
            <Tooltip title={translations[languagepreference].copyTheLink}>
              <FileCopyTwoToneIcon
                style={{ color: iconcolor }}
                onClick={copyToClipboard}
              ></FileCopyTwoToneIcon>
            </Tooltip>
          </div>
        )
      }
    </div>
  );
}
